import { render, staticRenderFns } from "./DomesticInquiryGrid.vue?vue&type=template&id=19c5d5a4"
import script from "./DomesticInquiryGrid.vue?vue&type=script&lang=js"
export * from "./DomesticInquiryGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports